import React from 'react';
interface SectionHeadingProps {
  kicker: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  kicker,
  title,
  subtitle,
  align = 'left',
  tone = 'light'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-257" data-mp="3k18au7gl9uk7">
      <p className={`text-sm font-semibold ${tone === 'dark' ? 'text-brand-cyan' : 'text-brand-blue'}`} data-id="element-258" data-mp="bjtze1w16y4r">
        {kicker}
      </p>
      <h2 className={`mt-2 font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl ${tone === 'dark' ? 'text-white' : 'text-navy'}`} data-id="element-259" data-mp="glav7iznrueh">
        {title}
      </h2>
      {subtitle && <p className={`mt-3 text-base leading-relaxed ${tone === 'dark' ? 'text-white/70' : 'text-ink/70'}`} data-id="element-260" data-mp="uizfaolwixih">
          {subtitle}
        </p>}
    </div>;
}